module.exports = "/_next/static/images/9237d43d80774a384c281edb2d90f091-holding-card-vertical@0.75x.png.webp";